module.exports = __webpack_public_path__ + "static/media/proj20_img4.52fba67b.jpg";